import React, { useEffect, useState } from 'react';
import BannerSection from '../sections/banner-section';
import { getData } from '@/services/api.service';
import BannerSectionEditModal from './modals/banner-edit-modal';
import TrustSection from '../sections/trust-section';
import LaundryEditModal from './modals/laundry-services-edit-modal';
import LaundryServicesSection from '../sections/laundry-services-section';
import ReviewSection from '../sections/review-section';
import ReviewEditModal from './modals/review-edit-modal';
import TrustEditModal from './modals/trust-edit-modal';
import HowWeWorksSection from '../sections/how-we-works-section';
import HowWeWorksEditModal from './modals/how-we-works-edit-modal';
import CategoriesSection from '../sections/categories-section';
import CategoryEditModal from './modals/category-edit-modal';
import AboutUsSection from '../sections/about-us-section';
import AboutUsEditModal from './modals/about-us-edit-modal';
import ServiceSections from '../sections/service-sections';
import ServiceEditModal from './modals/service-edit-modal';
import SafetySection from '../sections/safety-section';
import SafetyEditModal from './modals/safety-edit-modal';
import TestimonialSection from '../sections/testimonial-section';
import TestimonialEditModal from './modals/testimonial-edit-modal';
import MobileAppSection from '../sections/mobile-app-section';
import MobileAppEditModal from './modals/mobile-app-edit-modal';
import Header3 from '@/feature-module/common/header/header-3';
import Header3EditModal from '@/feature-module/common/header/edit/modals/header3-edit-modal';

const Home3Edit = ({ themeData, fetchData }: any) => {
  return (
    <>
      {/* <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#headerEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <>
          <Header3 themeData={themeData} />
        </>
      </div> */}
      {/* <div
        className="modal fade"
        id="headerEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <Header3EditModal themeData={themeData} fetchData={fetchData} />
      </div> */}

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#sectionBannerEditmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <BannerSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="sectionBannerEditmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <BannerSectionEditModal
          themeData={themeData}
          getThemeData={fetchData}
        />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#laundryEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <LaundryServicesSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="laundryEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <LaundryEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      {/* <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#reviewEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <ReviewSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="reviewEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <ReviewEditModal themeData={themeData} getThemeData={fetchData} />
      </div> */}

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#trustEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <TrustSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="trustEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <TrustEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#howWeWorksEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <HowWeWorksSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="howWeWorksEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <HowWeWorksEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#categoryEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <CategoriesSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="categoryEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <CategoryEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#aboutUsEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <AboutUsSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="aboutUsEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <AboutUsEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#serviceEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <ServiceSections themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="serviceEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <ServiceEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#safetyEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <SafetySection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="safetyEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <SafetyEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#testimonialEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <TestimonialSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="testimonialEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <TestimonialEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#mobileAppEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <MobileAppSection themeData={themeData} fetchData={fetchData} />
      </div>
      <div
        className="modal fade"
        id="mobileAppEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <MobileAppEditModal themeData={themeData} getThemeData={fetchData} />
      </div>
    </>
  );
};

export default Home3Edit;
